import { React, useState, useEffect, createContext, useMemo } from "react";
import request from "../../../Helpers/API";
import { Autocomplete, Button, Modal, Box, TextField, MenuItem, InputAdornment } from "@mui/material";
import Swal from "sweetalert2";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { format } from "echarts";

export const EsquemasporModeloModal = ({ open, onClose, id, modelo }) => {
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    const [esquemas, setEsquemas] = useState();

    useEffect(() => {
        if (open) {
            setLoader({ ...loader, mostrar: true });
            request
                .get(`PromocionesDisponibles/ObtenerEsquemasporModelo?idmodelo=${id}`)
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    setEsquemas(result);
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                });
        }
    }, [open]);

    return (
        <>
            <Modal open={open} onClose={onClose}>
                <div className="esquemas-modal-formulario">
                    <div className="esquemas-modal-plantilla">
                        <div className="plantilla-screen-filtro-container" id="mdlFiltros-modal">
                            <PlantillaScreen
                                titulo={modelo}
                                className_main={1}
                                className={"plantilla-screen-filtro-container-modal"}
                            >
                                <div className="cerrar-modal-button" onClick={onClose}>X</div>
                                <div className={`esquemas-modal`}>
                                    <div className="esquemas-modal-container">
                                        <div className='esquemas-modal-container-table scroll-4'>
                                            <table cellPadding={0} cellSpacing={0}>
                                                <thead>
                                                    <tr>
                                                        <th>Esquema</th>
                                                        <th><div>Precio Normal</div></th>
                                                        <th><div>Descuento</div></th>
                                                        <th><div>Oferta</div></th>
                                                        <th><div>Vigencia</div></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {esquemas && esquemas.length > 0 && (
                                                        esquemas.map((item, index) => (
                                                            <tr key={index}>
                                                                <td className="celda-descripcion">{item.descripcion_promocion}</td>
                                                                <td className="celda-importe">{FormatMoney(item.precio_lista)}</td>
                                                                <td className="celda-importe">{FormatMoney(item.descuento)}</td>
                                                                <td className="celda-importe">{FormatMoney(item.precio_promocion)}</td>
                                                                <td className="celda-vigencia">{item.inicio_vigencia} al {item.vigencia}</td>
                                                            </tr>
                                                        ))
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </PlantillaScreen>
                        </div>

                    </div>
                </div>
            </Modal >
        </>
    );
};